export type UpdateComponentDeploymentRequestsStatusRequest = {
  dplymntReqSeqList: DplymntReqSeq[];
};

type DplymntReqSeq = {
  index: number;
  processTyp: string;
  dplymntReqSeq: string;
  updateDtimeTDplymntReqMng: string;
  tcktStsIdFrom: string;
  reviewComment?: string;
};
